<template>
    <div class="w-full h-fit relative overflow-hidden bg-white py-0 transition-all duration-300 max-h-0 opacity-0" :class="stepform === 0 ?'active-component' : ''">
        <div class="flex w-full h-fit absolute top-0 left-0">
            <span class="top-variation w-[18px] h-[16px] rounded-full transform -translate-x-[60%] -translate-y-[25%]"
                style="background: linear-gradient(0deg, #FBF3FF 0%, #EEF2FC 54.20%, #F1F4FE 100%);"></span>
            <div class="w-[95%] h-[6px]"
                v-bind:style="{ 'background-image': 'url(' + $settings.images + '/svg/ellips.svg)' }"></div>
            <span class="top-variation w-[18px] h-[16px] rounded-full transform translate-x-[60%] -translate-y-[25%]"
                style="background: linear-gradient(0deg, #FBF3FF 0%, #EEF2FC 54.20%, #F1F4FE 100%);"></span>
        </div>

        <div class="px-4 lg:px-6 flex flex-col gap-1 max-w-[480px] pb-4 lg:pb-6 pricing-included">
            <div class="flex gap-2 items-center max-w-[480px] included-label">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" fill="white" />
                    <rect x="4.30442" y="3.74048" width="15.3912" height="18.2595" rx="2.5" stroke="black"
                        stroke-width="1.3" />
                    <path d="M7.80512 14.2645L16.1947 14.2645" stroke="black" stroke-width="1.3" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M7.80512 17.7946H13.6885" stroke="black" stroke-width="1.3" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path
                        d="M7.81223 3.71604V3.69404C7.81223 2.75845 8.57068 2 9.50627 2V2C10.4419 2 11.2003 2.75845 11.2003 3.69404V8.33452C11.2003 9.27011 10.4419 10.0286 9.50627 10.0286V10.0286C8.57068 10.0286 7.81223 9.27011 7.81223 8.33452V6.09627"
                        stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span class="font-default font-medium text-black leading-[25.6px] tracking-[0.16px]">Includes:</span>
            </div>
            <div class="included-benefit">
                <p class="font-default text-[#454B57] text-[14px] leading-[25.2px] tracking-[0.14px]" v-if="selectedServices.length > 0">Project Manager, Creative Director,
                    <br>Unlimited design request<span class="text-[#E22D3D]">*</span>, Unlimited revision<span class="text-[#E22D3D]">**</span></p>
                <p v-else class="font-default text-[#454B57] text-[14px] leading-[25.2px] tracking-[0.14px]">Benefits</p>

            </div>
        </div>

        <div class="px-4 lg:px-6 pb-5 pricing-durations">
            <div class="flex gap-2 items-center max-w-[480px] durations-label">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M17.55 4.80002H6.45004C4.79319 4.80002 3.45004 6.14316 3.45004 7.80002V18C3.45004 19.6569 4.79319 21 6.45004 21H17.55C19.2069 21 20.55 19.6569 20.55 18V7.80002C20.55 6.14316 19.2069 4.80002 17.55 4.80002Z"
                        stroke="black" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3.44998 8.80005L20.5053 8.80005" stroke="black" stroke-width="1.3" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <circle cx="7.50008" cy="12.6094" r="0.9" fill="black" />
                    <circle cx="7.50008" cy="16.2092" r="0.9" fill="black" />
                    <circle cx="11.1001" cy="16.2094" r="0.9" fill="black" />
                    <path d="M7.50003 3.00002L7.50003 4.80002" stroke="black" stroke-width="1.3" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M16.5 3.00002L16.5 4.80002" stroke="black" stroke-width="1.3" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>

                <template v-if="selectedPeriod === null">
                    <span class="body-1 font-medium ">Duration: <span v-if="projectDurationsCount > 0">{{projectDurationsCount}}</span> <span
                        class="body-1 text-[#454B57]">{{projectDurations}}</span></span>
                </template>

                <template v-if="selectedPeriod !== null && selectedPeriod.minimalBooking < 2">
                    <span class="body-1 font-medium ">Duration: <span v-if="projectDurationsCount > 0">{{projectDurationsCount}}</span> <span
                        class="body-1 text-[#454B57]">{{projectDurations}}</span></span>
                </template>
                <template v-if="selectedPeriod !== null && selectedPeriod.minimalBooking >= 2">
                    <span class="font-default font-medium text-black leading-[25.6px] tracking-[0.16px]">Duration: <span>140</span> <span
                        class="font-default font-medium leading-[25.6px] tracking-[0.16px] text-[#454B57]">hours/month</span></span>
                </template>
            </div>
        </div>

        <div class="px-4 lg:px-6 pricing-descritions">
            <div
                class="w-full h-fit pl-4 lg:pl-[21px] pr-4 lg:pr-[21px] pt-[16px] pb-[16px] border border-[#EDEDEF] rounded-[20px] min-h-[148px] mb-8 lg:mb-5">
                <div class="flex gap-2 items-center max-w-[480px] pb-5 descritions-label">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M9.7496 17.4023L4.99669 18.3005L5.98112 13.6338L14.3657 5.16427C15.4047 4.11469 17.0992 4.11042 18.1436 5.15475V5.15475C19.1805 6.19167 19.1847 7.87153 18.153 8.91365L9.7496 17.4023Z"
                            stroke="black" stroke-width="1.3" stroke-miterlimit="10" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M13.374 6.45682L17.0406 10.0634" stroke="black" stroke-width="1.3"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3 20.7389H21" stroke="black" stroke-width="1.3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>

                    <span class="font-default font-medium text-black leading-[25.6px] tracking-[0.16px]">Description</span>
                </div>

                <div v-if="selectedServices.length">
                    <div v-for="(service, index) in selectedServices" :key="index">
                        <div class="pl-[21px] lg:pl-4 border-l-2"
                            :style="'border-color:' + service.setting.borderColor + ';'">
                            <p class="font-default font-medium text-[14px] leading-[19.6px] tracking-[0.14px] text-[#000]">
                                {{ service.serviceName }}</p>
                            <p class="font-default text-[14px] font-normal leading-[22.4px] tracking-[0.14px] text-[#454B57]">
                                {{ service.desc }}</p>
                        </div>
                        <div class="py-4 pl-4 w-full" v-if="index < (selectedServices.length -1)">
                            <div class="h-[1px] w-full bg-[#EDEDEF]"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="hidden px-4 lg:px-6 lg:flex gap-2 mb-5">
            <span class="font-default text-[#454B57] text-[14px] leading-[25.2px] tracking-[0.14px]"><span class="text-[#E22D3D]">*</span>Within the project timeline,
            </span>
            <span class="font-default text-[#454B57] text-[14px] leading-[25.2px] tracking-[0.14px]"><span class="text-[#E22D3D]">**</span>Based on realistic project scope</span>
        </div>

        <!-- <p class="lg:hidden px-4 lg:px-6 body-2 text-[#454B57]"><span class="text-[#E22D3D]">*</span>based on realistic project scope, <span class="text-[#E22D3D]">**</span>within the project timeline</p> -->

        <div class="w-full h-6 relative">
            <div class="w-6 h-6 rounded-full absolute top-0 left-0 transform -translate-x-1/2"
                style="background: linear-gradient(0deg, #FBF3FF 0%, #EEF2FC 54.20%, #F1F4FE 100%);"></div>
            <div class="w-[95%] h-[10px] top-full transform translate-y-1/2 translate-x-[18px]"
                v-bind:style="{ 'background-image': 'url(' + $settings.images + '/svg/ellips2.svg)' }"></div>
            <div class="w-6 h-6 rounded-full absolute top-0 right-0 transform translate-x-1/2"
                style="background: linear-gradient(0deg, #FBF3FF 0%, #EEF2FC 54.20%, #F1F4FE 100%);"></div>
        </div>

        <div class="px-4 lg:px-6 pt-5 pb-5 flex w-full justify-between items-center">
            <div class="w-fit flex flex-col gap-[6px]">
                <p class="font-default font-medium text-[14px] text-[#454B57] leading-[22.4px] tracking-[0.14px]">Estimated cost</p>
                <p class="font-default font-semibold text-black text-[32px] leading-[44.8px]">${{moneyFormatUSA(subtotal)}} 
                    <span v-if="projectBook >= 2" class="font-default text-[14px] leading-[22.4px] tracking-[0.14px] text-[#6D727E] font-normal">/month</span>
                    <span v-if="projectBook > 0 && projectBook < 2" class="font-default text-[14px] leading-[22.4px] tracking-[0.14px] text-[#6D727E] font-normal">/week</span>
                    <template v-if="total > 0 && selectedPeriod !== null && selectedPeriod.discount > 0">
                        <span
                            class="font-default text-[14px] leading-[22.4px] tracking-[0.14px] text-[#454B57] font-medium lg:pl-[6px] line-through hidden lg:inline">${{moneyFormatUSA(total)}}</span>
                    </template>
                </p>
                <template v-if="total > 0 && selectedPeriod !== null && selectedPeriod.discount > 0">
                    <p class="font-default text-[14px] leading-[22.4px] tracking-[0.14px] text-[#454B57] font-medium lg:pl-[6px] line-through lg:hidden">
                        ${{moneyFormatUSA(total)}}</p>
                </template>
            </div>

            <button aria-label="Next-Form"
            class="btn max-lg:icon-only btn__primary icon-trailing ico ico__arrow_point_right text-[14px] leading-[24px] max-lg:w-[48px] h-[48px] lg:px-6 items-center justify-center"
            @click="getPriceHandler()"><span class="max-lg:hidden">Get this
                    price</span></button>
        </div>

        <transition>
            <div class="px-4 lg:px-6" v-if="subtotal > 0">
                <div class="px-4 py-[15px] border border-[#CBD4EC] rounded-[20px] flex gap-[10px]">
                    <div
                        class="w-fit h-fit max-lg:p-2 lg:w-9 lg:h-9 flex items-center justify-center rounded-full bg-[#EAEDF7]">
                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"
                            class="max-lg:w-6 max-lg:h-6">
                            <path
                                d="M14.238 17.9997H4.8818C3.04085 17.9997 1.54846 16.5073 1.54846 14.6664V14.2217H11.8391"
                                stroke="#0F39A6" stroke-width="1.08333" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M11.8389 14.2198L11.8385 15.6929C11.8381 16.967 12.8708 18 14.1449 18V18C15.4187 18 16.4513 16.9674 16.4513 15.6936V3.36616C16.4513 3.16411 16.2875 3.00031 16.0855 3.00031L4.67571 3.00001C4.44559 3 4.25903 3.18655 4.25903 3.41668V14.2198"
                                stroke="#0F39A6" stroke-width="1.08333" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M7.85522 6.3335H12.8552" stroke="#0F39A6" stroke-width="1.08333"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.85522 8.8335H12.8552" stroke="#0F39A6" stroke-width="1.08333"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.85522 11.3335H10.3552" stroke="#0F39A6" stroke-width="1.08333"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="flex flex-col gap-1">
                        <p
                            class="text-[14px] lg:text-[16px] font-medium leading-[19.36px] tracking-[0.16px] text-[#020B1F]">
                            This is only an estimation!</p>
                        <p class="text-[13px] lg:text-[14px] leading-[22px] tracking-[0.14px] text-[#454B57]">You
                            can
                            talk to us first and negotiate to find your best price</p>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    export default {
        props: {
            benefits: {
                type: String,
                default: ''
            },
            selectedServices: {
                type: Array,
                default: []
            },
            benefitsStarted: {
                type: Array,
                default: []
            },
            subtotal: {
                type: Number,
                default: 0
            },
            total: {
                type: Number,
                default: 0
            },
            projectDurations: {
                type: String,
                default: ''
            },
            projectDurationsCount: {
                type: Number,
                default: 0
            },
            stepform: {
                type: Number,
                default: 0,
            },
            selectedPeriod: {
                type: Object,
                default: {}
            },
            minimalBook: {
                type: Number,
                default: 2
            }
        },
        data() {
            return {
                projectBook: 0
            }
        },

        watch: {
            minimalBook: {
                handler(){
                    this.projectBook = this.minimalBook
                    if (this.selectedPeriod !== null) {
                        this.projectBook = this.selectedPeriod.minimalBooking
                    }
                }
            },
            selectedPeriod: {
                handler(){
                    this.projectBook = this.selectedPeriod.minimalBooking
                }
            }
        },
        methods: {
            getPriceHandler() {
                if (this.selectedServices !== '' && this.selectedPeriod !== null) {
                this.$emit('getPrice');
                } else {
                if (this.selectedServices == '') {
                    this.$emit('update-Services', false);
                }
                if (this.selectedPeriod === null) {
                    this.$emit('update-Period', false);
                }
                }

            },
        },

    }
</script>
<style lang="scss" scoped>
    .active-component{
        @apply max-h-[100000px] opacity-100 py-8;
    }
</style>